import { useEffect, useState } from 'react';

const canMatchMedia = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() =>
    canMatchMedia() ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (!canMatchMedia()) {
      setMatches(false);
      return undefined;
    }

    const mediaQuery = window.matchMedia(query);
    const updateMatches = (event?: MediaQueryListEvent): void => {
      setMatches(event?.matches ?? mediaQuery.matches);
    };

    updateMatches();
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', updateMatches);
      return () => mediaQuery.removeEventListener('change', updateMatches);
    }

    mediaQuery.addListener(updateMatches);
    return () => mediaQuery.removeListener(updateMatches);
  }, [query]);

  return matches;
};

export default useMediaQuery;
